import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Briefcase } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const CareersHero = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="relative pt-32 pb-24 px-6 bg-gradient-to-b from-gray-900 via-gray-950 to-gray-950 overflow-hidden">
      {/* Background grid */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f2937_1px,transparent_1px),linear-gradient(to_bottom,#1f2937_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-20" />
      
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-900/30 border border-blue-700 rounded-full mb-6">
            <Briefcase className="w-4 h-4 text-blue-400" />
            <span className="text-sm text-blue-300 font-medium">Join Our Team</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Build the future of
            <br />
            <span className="text-blue-400">AI-powered training & enablement</span>
          </h1>
          
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-10">
            At Traain, we are transforming how companies train and develop their teams. Join us in building the AI platform that is reshaping workforce enablement for the modern era.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              size="lg"
              onClick={openCalendly}
              className="bg-blue-600 hover:bg-blue-700 text-lg px-8 py-6"
            >
              Let's Talk
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => document.getElementById('why-traain')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-gray-700 text-gray-300 hover:bg-gray-800 text-lg px-8 py-6"
            >
              Learn More
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid md:grid-cols-3 gap-8 mt-20">
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-400 mb-2">100+</div>
            <p className="text-gray-400">Enterprise Customers</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-400 mb-2">500K+</div>
            <p className="text-gray-400">AI Role-Plays Powered</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-400 mb-2">Remote</div>
            <p className="text-gray-400">First Culture</p>
          </div>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default CareersHero;
